module.exports = __webpack_public_path__ + "3806c79a.png";